export const COLORS = {
  // Базовая монохромная палитра
  black: 0x0a0a0a,
  darkGray: 0x1f1f1f,
  midGray: 0x4a4a4a,
  lightGray: 0xb8b8b8,
  white: 0xe8e8e8,

  // Цветовые акценты со смыслом
  green: 0x39ff14, // ЗАРАЖЕНИЕ
  red: 0xff1744, // УРОН
  yellow: 0xffb800, // ТРИУМФ
  blue: 0x00d4ff, // СИЛА
} as const;

export const HEX = {
  black: '#0A0A0A',
  darkGray: '#1F1F1F',
  midGray: '#4A4A4A',
  lightGray: '#B8B8B8',
  white: '#E8E8E8',
  green: '#39FF14',
  red: '#FF1744',
  yellow: '#FFB800',
  blue: '#00D4FF',
} as const;
